"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function CloudLayout({ children }) {
  const isdark = useIsDark();
  return (
    <div>
      {/* left top  */}
      <section
        className="relative  xl:translate-y-0"
        style={{
          willChange: "transform",
          transform: "translateZ(0)",
        }}
      >
        <div
          className={twMerge(
            "absolute top-[807px] left-[-25px] w-[313px] h-[272px] rounded-full rotate-126 blur-[100px]",
            isdark ? "bg-[#8593E8] opacity-20" : "bg-[#A1ADF5] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[753px] left-[-123px] w-[315px] h-[274px] rounded-full rotate-126 blur-[120px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1100px] left-[-179px] w-[300px] h-[262px] rounded-full blur-[100px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      {/* right middle */}
      <section
        className="relative translate-y-120 xl:translate-y-0"
        style={{
          willChange: "transform",
          transform: "translateZ(0)",
        }}
      >
        <div
          className={twMerge(
            "absolute top-[1500px] right-[-135px] w-[271px] h-[313px] rounded-full blur-[100px]",
            isdark ? "bg-[#8593E8] opacity-20" : "bg-[#A1ADF5] opacity-60"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1700px] right-[-50px] w-[274px] h-[315px] rounded-full blur-[120px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1900px] right-[-154px] w-[262px] h-[300px] rounded-full blur-[100px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      {/* left bottom */}
      <section className="relative translate-y-100 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[2947px] left-[-170px] lg:left-[-62px] w-[300px] h-[262px] rounded-full rotate-126 blur-[120px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[3169px] left-[-250px] lg:left-[-131px] w-[315px] h-[275px] rounded-full  rotate-126 blur-[100px]",
            isdark ? "bg-[#5D6EF3] opacity-40" : "bg-[#2A40E7] opacity-40"
          )}
        />
      </section>

      <div className="">{children}</div>
    </div>
  );
}
